export default "__VITE_ASSET__Cp$ZWfeF__"